const buildQueryParams = ({ search, filters, page, pageSize }) => {
    const params = new URLSearchParams();

    if (search?.trim()) {
        params.append("search", search.trim());
    }

    if (typeof page === "number") {
        params.append("page", page);
    }

    if (typeof pageSize === "number") {
        params.append("size", pageSize);
    }

    if (filters && typeof filters === "object") {
        Object.entries(filters).forEach(([key, value]) => {
            if (value === null || value === undefined) return;

            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v !== null && v !== undefined) {
                        params.append(key, String(v));
                    }
                });
                return;
            }

            params.append(key, String(value));
        });
    }

    return Object.fromEntries(params.entries());
};

export default buildQueryParams;